import { getHeadersAndEndpointApiUtil } from 'modules/api/utils'
import fetchNetworkUtil from 'modules/training/modules/network/utils/fetch'
import { hideLoaderDomUtil, showLoaderDomUtil } from 'client/utils/dom'

async function deleteApiService (endpointParam, data, options) {
  if (BROWSER) {
    showLoaderDomUtil()
  }

  const { headers, endpoint } = getHeadersAndEndpointApiUtil(endpointParam, options)
  const response = await fetchNetworkUtil(endpoint, {
    credentials: 'include',
    headers,
    method: 'DELETE',
    body: JSON.stringify(data)
  })
  const json = await response.json()
  if (response.ok) {
    if (BROWSER) {
      hideLoaderDomUtil()
    }
    return json
  }
  if (BROWSER) {
    hideLoaderDomUtil()
  }
  throw json
}

export default deleteApiService
